export const userType = {
  SET_USER_INFO: "SET_USER_INFO",
  SET_PERMISSIONS: "SET_PERMISSIONS"
};
